export const FALLBACK_IMAGE_BASE_URL = "https://image.tmdb.org/t/p/";
export const FALLBACK_POSTER_IMAGE_SIZE = "w342";
export const FALLBACK_BACKDROP_IMAGE_SIZE = "w1280";
export const FALLBACK_PROFILE_IMAGE_SIZE = "w185";
export const SCROLL = "scroll_"
export const POSTER = "poster"
export const BACKDROP = "backdrop"
export const PROFILE = "profile"